import theme from '@styles/theme';
export default {
  container: {
    width: '100%',
    height: 'auto',
    borderBottom: `2px solid ${theme.rawColors.lightGrey300}`,
    m: '8px 0 16px 0',
    button: {
      mb: '-2px',
      p: '4px 16px',
      zIndex: theme.zIndex.documentUp
    }
  },
  activeButton: (active: boolean) => ({
    borderBottom: `2px solid ${active ? theme.rawColors.darkGrey500 : theme.rawColors.lightGrey300}`
  })
};